<db-dialog-wrapper [dialog]="this" [width]="'450px'" [height]="'515px'">
  <div class="db-changelog">
    <div class="db-changelog__logo">
      <div [ngClass]="{'theme-logo': product.type === 'theme'}" [ngStyle]="{backgroundImage: 'url(' + product.logo + ')'}"></div>
      <h4>{{product.title}}</h4>
      <p>{{'text_newVersion' | dbText}} {{product.currentVersion.paid}}</p>
    </div>
    <div class="db-changelog__versions">
      <div>
        <div class="changelog-wrap">
            <div><p class="db-changelog__title">{{'text_versions' | dbText}}</p></div>
            <div class="db-changelog-info" *ngFor="let change of (changes | sortBy : 'versionNumber' : 'desc' );">
              <div class="db-changelog__version-number"><p>{{change.version}}</p></div>
              <div class="db-changelog__version-description"><p [innerHTML]="change.changelog | breakText"></p></div>
            </div>
        </div>
      </div>
    </div>
    <div class="db-changelog__update">
      <a class="db-button db-button_lg" (click)="close()" [ngClass]="{'db-button_disabled': !isManagable}"><span>{{'text_updateLater' | dbText}}</span></a>
      <a class="db-button db-button_info db-button_lg" (click)="update()" [ngClass]="{'db-button_disabled': !isManagable}"><span>{{'text_update' | dbText}}</span></a>
    </div>
  </div>
  <db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
</db-dialog-wrapper>
